export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12198.2741d893.jpg";